import _ from "lodash";
import { formatName } from "../utils/formatUtil";

export const images: Record<string, any> = {
  cats: (() => {
    const ctx = require.context(
      '../assets/images/cats', // parent folder
      true,                      // recursive: yes
      /\.(png|jpe?g|gif|webp|svg)$/i
    );

    const result: Record<string, string[]> = {};

    ctx.keys().forEach((key: string) => {
      // key looks like: "./andy/IMG_001.jpg" or "./rudy/jump.png"
      const pathParts = key.replace('./', '').split('/'); // ["andy", "IMG_001.jpg"]
      const kittenName = pathParts[0];                    // "andy", "rudy", etc.

      // Initialize array if this is the first image for this kitten
      if (!result[kittenName]) {
        result[kittenName] = [];
      }

      // Get the actual URL (works in CRA)
      const imageUrl = (ctx(key).default || ctx(key)) as string;
      result[kittenName].push(imageUrl);
    });

    return result;
  })(),
  kittens: (() => {
    const ctx = require.context(
      '../assets/images/kittens', // parent folder
      true,                      // recursive: yes
      /\.(png|jpe?g|gif|webp|svg)$/i
    );

    const result: Record<string, string[]> = {};

    ctx.keys().forEach((key: string) => {
      // key looks like: "./andy/IMG_001.jpg" or "./rudy/jump.png"
      const pathParts = key.replace('./', '').split('/'); // ["andy", "IMG_001.jpg"]
      const kittenName = pathParts[0];                    // "andy", "rudy", etc.

      // Initialize array if this is the first image for this kitten
      if (!result[kittenName]) {
        result[kittenName] = [];
      }

      // Get the actual URL (works in CRA)
      const imageUrl = (ctx(key).default || ctx(key)) as string;
      result[kittenName].push(imageUrl);
    });

    return result;
  })(),
  litters: (() => {
    const ctx = require.context(
      '../assets/images/litters', // parent folder
      true,                      // recursive: yes
      /\.(png|jpe?g|gif|webp|svg)$/i
    );

    const result: Record<string, string[]> = {};

    ctx.keys().forEach((key: string) => {
      // key looks like: "./andy/IMG_001.jpg" or "./rudy/jump.png"
      const pathParts = key.replace('./', '').split('/'); // ["andy", "IMG_001.jpg"]
      const kittenName = pathParts[0];                    // "andy", "rudy", etc.

      // Initialize array if this is the first image for this kitten
      if (!result[kittenName]) {
        result[kittenName] = [];
      }

      // Get the actual URL (works in CRA)
      const imageUrl = (ctx(key).default || ctx(key)) as string;
      result[kittenName].push(imageUrl);
    });

    return result;
  })()
} as const

function collectArrayValues<T = string>(obj: any): T[] {
  return _.reduce(
    obj,
    (acc: T[], val) => {
      if (_.isArray(val)) {
        return acc.concat(val as T[]);
      }
      if (_.isObject(val)) {
        return acc.concat(collectArrayValues<T>(val));
      }
      return acc;
    },
    []
  );
}

export const allImages = collectArrayValues(images);

export default class ImageLoader {
  public loadImages(propName1: string, propName2: string) {
    console.log(formatName(propName2))
    return images?.[propName1]?.[formatName(propName2)];
  }
}